import { useRouter } from 'next/router'
import React, { VFC } from 'react'

import { Personalization } from '@Components/Personalization/Modals/Shared'
import {
  PersonalizationButtonSpan,
} from '@Components/Personalization/Styles/Personalization.styled'

type ButtonLayoutType = Pick<Personalization, 'price' | 'placement'>

export const PersonalizationButtonLayout: VFC<ButtonLayoutType> = ({
  placement,
  price,
}) => {
  const { locale = 'en-GB' } = useRouter()
  return (
    <>
      {placement && (
        <PersonalizationButtonSpan capitalize>
          {placement[locale]}
        </PersonalizationButtonSpan>
      )}
      <PersonalizationButtonSpan>
        {price}
      </PersonalizationButtonSpan>
    </>
  )
}

